<h3 i18n="Title for save image dialog in the story creation process@@SAVE_CHANGES">Save my changes and continue creating my story?</h3>

<button class="text-btn" (click)="dialogRef.close()" i18n="Text for the button to cancel the action in progress@@CANCEL">Cancel</button>
<button class="submit" (click)="dialogRef.close(true)" i18n="Text for the button to save current changes@@SAVE">Save</button>
